import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";

import { Constants, Formats } from "../core/constants";
import { ContextService } from "../core/context.service";
import { ConfirmationDialogComponent } from "./confirmation.dialog.component";
import * as moment from "moment";

@Component({
  selector: "tv-detail-actions",
  templateUrl: "./detail.actions.component.html",
  styleUrls: ["./detail.actions.component.css"],
})
export class DetailActionsComponent implements OnInit {
  @Input() showSave: boolean = true;
@Input() showDelete: boolean = true;
@Input() showAuthorise: boolean = true;
@Input() disableSave: boolean = false;
@Input() disabledelete: boolean = false;
  @Input()
  public onSave: () => boolean;

  @Input()
  public onAuthorise: () => boolean;

  @Input()
  public onDelete: () => void;

  @Input()
  public onBeforeCancel: () => boolean;

  @Input()
  public onDoingCancel: () => any;

  @Input()
  public deleteDescription: string;

  @Input()
  public linkCustomer: boolean;

  @Input()
  public onLinkedCustomer: () => any;

  @Input()
  public model: any;

  @Input()
  public onPreview: () => void;

  isSaveEnabled = false;
  isAuthoriseEnabled = false;
  isDeleteEnabled = false;
  fromAuthorisation: any;
  isSameDay = false;
  isPreviewEnabled = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private constants: Constants,
    private formats: Formats,
    private contextService: ContextService
  ) {}

  ngOnInit() {
    console.log("List Actions route snap shot ", this.route.snapshot.data);
    const detailIndex =
      this.router.routerState.snapshot.url.indexOf("/detail/");

    const screens = this.route.snapshot.data["screens"];
    this.isSaveEnabled =
      this.contextService.hasActionPermission(
        screens,
        this.constants.ScreenAction.Create
      ) ||
      this.contextService.hasActionPermission(
        screens,
        this.constants.ScreenAction.Update
      );
    this.isAuthoriseEnabled = this.contextService.hasActionPermission(
      screens,
      this.constants.ScreenAction.Authorise
    );
    this.isDeleteEnabled = this.contextService.hasActionPermission(
      screens,
      this.constants.ScreenAction.Delete
    );
    console.log(screens);
    if (
      screens[0] == "customerdetail" ||
      screens[1] == "customerdetail" ||
      screens[0] == "companylist" ||
      screens[1] == "companydetail"
    ) {
      this.isPreviewEnabled = true;
    } else if (screens[0] == "screen") {
      this.isAuthoriseEnabled = false;
      this.isDeleteEnabled = false;
    }
    console.log(
      "Flags id ",
      this.isSaveEnabled,
      this.isAuthoriseEnabled,
      this.isDeleteEnabled,
      this.isPreviewEnabled
    );

    const branchDate = moment(this.contextService.currentDate);
    const createdDate = moment(this.model?.changedDate);
    console.log("is same day entries", branchDate, createdDate);
    if (
      createdDate.format(this.formats.SERIALISATION_FORMAT) ===
      branchDate.format(this.formats.SERIALISATION_FORMAT)
    ) {
      this.isSameDay = true;
      console.log("is same day entries");
    }
  }

  // save() {
  //   this.isSaveEnabled = false;
  //   if (this.onSave !== null) {
  //     try {
  //       const response = this.onSave();
  //       const url = this.router.routerState.snapshot.url;
  //       // this.router.navigate([url]);
  //       if (response === true) {
  //         this.isSaveEnabled = true;
  //       }
  //     } catch (error) {
  //       this.isSaveEnabled = true;
  //       console.log("Error in details save action.", error);
  //     }
  //   }
  // }

  // save() {
  //   if (!this.isSaveEnabled) return; 

  //   this.isSaveEnabled = false;

  //   try {
  //     const response = this.onSave();
  //     if (response === true) {
  //       this.isSaveEnabled = true; 
  //     } else {
  //       this.isSaveEnabled = false; 
  //     }
  //   } catch (error) {
  //     this.isSaveEnabled = true; 
  //     console.log("Error in details save action.", error);
  //   }
  // }
  async save() {
    if (!this.isSaveEnabled) return;
  
    this.isSaveEnabled = false;
  
    try {
      const response = await this.onSave(); // Wait for parent save to finish
      this.isSaveEnabled = !response ? true : false; // Re-enable if failed
    } catch (error) {
      this.isSaveEnabled = true;
      console.error("Error in details save action.", error);
    }
  }
  
  // save() {
  //   if (!this.isSaveEnabled) return; 

  //   this.isSaveEnabled = false;

  //   try {
  //     const response = this.onSave();
  //     if (response === true) {
  //       this.isSaveEnabled = true; 
  //     } else {
  //       this.isSaveEnabled = false; 
  //     }
  //   } catch (error) {
  //     this.isSaveEnabled = true; 
  //     console.log("Error in details save action.", error);
  //   }
  // }

  authorise() {
    this.isAuthoriseEnabled = false;
    if (this.onAuthorise !== null) {
      try {
        const response = this.onAuthorise();
        if (response === true) {
          this.isAuthoriseEnabled = true;
        }
      } catch (error) {
        console.log("Error in details authorise action.", error);
      }
    }
  }

  delete() {
    if (this.onDelete !== null) {
      try {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          data: {
            message: "Are you sure want to delete?",
            description: this.deleteDescription,
            buttonText: {
              ok: "Yes",
              cancel: "No",
            },
          },
        });
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.onDelete();
          }
        });
      } catch (error) {
        console.log("Error in details delete action.", error);
      }
    }
  }

  cancel() {
    if (this.onDoingCancel !== null) {
      let leaveScreen = true;
      const cancelData = this.onDoingCancel();
      if (cancelData.hasUnsavedChanges === true) {
        leaveScreen = confirm(
          "There are unsaved changes on this page and they will be lost." +
            "Are you sure you want to leave this page without saving?"
        );
      }

      if (leaveScreen === true) {
        this.router.navigate([cancelData.routerLink]);
      }
    }
  }

  linkedCustomer() {
    if (this.onLinkedCustomer !== null) {
      try {
        const response = this.onLinkedCustomer();
      } catch (error) {
        console.log("Error in details link customer action.", error);
      }
    }
  }

  preview() {
    this.onPreview();
  }
}
